// Central place for All Things Social Impact social links.
// Update these once - Footer, Podcast page and any future share/subscribe UI read from here.
export const SOCIAL_LINKS = [
  {
    key: "youtube",
    label: "YouTube",
    handle: "@AllThingsSocialImpact",
    url: "https://www.youtube.com/@AllThingsSocialImpact",
    icon: "Youtube", // lucide-react
  },
  {
    key: "spotify",
    label: "Spotify",
    handle: "Voices of Change",
    url: "https://open.spotify.com/show/4RLkmfuAUYC8XVoeISCzKv",
    icon: "Podcast",
  },
  {
    key: "substack",
    label: "Substack",
    handle: "@andreajk",
    url: "https://substack.com/@andreajk",
    icon: "Newspaper",
  },
  {
    key: "linkedin",
    label: "LinkedIn",
    handle: "Andrea Kanaris",
    url: "https://www.linkedin.com/in/andreakanaris/",
    icon: "Linkedin",
  },
  {
    key: "instagram",
    label: "Instagram",
    handle: "@allthingssocialimpact",
    url: "https://www.instagram.com/allthingssocialimpact/",
    icon: "Instagram",
  },
  {
    key: "facebook",
    label: "Facebook",
    handle: "All Things Social Impact",
    url: "https://www.facebook.com/profile.php?id=61573177821790",
    icon: "Facebook",
  },
  {
    key: "tiktok",
    label: "TikTok",
    handle: "@all.things.social12",
    url: "https://www.tiktok.com/@all.things.social12",
    icon: "Music2",
  },
  {
    key: "x",
    label: "X",
    handle: "@AllThingsSI",
    url: "https://x.com/AllThingsSI",
    icon: "Twitter",
  },
];
